import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-6 duration-150 transition-opacity" }
const _hoisted_3 = { class: "col-span-12" }
const _hoisted_4 = { class: "mt-1" }

import { reactive } from 'vue'
import { useRouter } from 'vue-router'

import { duplicatorAttributes } from '@/helpers/duplicator'
import api from '@/store/api'


export default {
  __name: 'DropNew',
  setup(__props) {

const router = useRouter()

const drop = reactive({
  description: ''
})

const saveDrop = () => {
  api
    .call('POST', `bottle_cycles`, {
      bottle_cycle: {
        description: drop.description,
        duplicator_attributes: duplicatorAttributes()
      }
    })
    .then(response => {
      router.push(`/store/drops/${response.data.data.id}#new`)
    })
}

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_BasicContainer = _resolveComponent("BasicContainer")
  const _component_MainCol = _resolveComponent("MainCol")
  const _component_SideCol = _resolveComponent("SideCol")
  const _component_PageGrid = _resolveComponent("PageGrid")
  const _component_PageFooter = _resolveComponent("PageFooter")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, {
        text: drop.description || 'New drop'
      }, {
        right: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/automation/drop/new" }, {
            default: _withCtx(() => [
              _createVNode(_component_NeueButton, { type: "secondary" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("span", { class: "hidden sm:inline" }, "Go to the new version of this page", -1),
                  _createElementVNode("span", { class: "inline sm:hidden" }, "Go to new version", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["text"])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          class: "flex flex-1 flex-col justify-between",
          onSubmit: _withModifiers(saveDrop, ["prevent"])
        }, [
          _createVNode(_component_PageGrid, null, {
            default: _withCtx(() => [
              _createVNode(_component_MainCol, null, {
                default: _withCtx(() => [
                  _createVNode(_component_BasicContainer, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _cache[3] || (_cache[3] = _createElementVNode("label", {
                            for: "tier-name",
                            class: "block text-sm font-medium text-gray-700"
                          }, "Description", -1)),
                          _createElementVNode("div", _hoisted_4, [
                            _withDirectives(_createElementVNode("input", {
                              id: "drop-description",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((drop.description) = $event)),
                              type: "text",
                              name: "tier-name",
                              class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                            }, null, 512), [
                              [_vModelText, drop.description]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_SideCol)
            ]),
            _: 1
          }),
          _createVNode(_component_PageFooter, null, {
            left: _withCtx(() => [
              _createElementVNode("button", {
                class: "btn-alert",
                type: "button",
                onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.deleteDrop && _ctx.deleteDrop(...args)), ["prevent"]))
              }, "Delete")
            ]),
            right: _withCtx(() => [
              _createVNode(_component_router_link, {
                class: "btn-ghost mr-3",
                to: "/store/membership-tiers"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createElementVNode("button", {
                class: "btn-primary",
                type: "submit"
              }, "Save", -1))
            ]),
            _: 1
          })
        ], 32)
      ])
    ]),
    _: 1
  }))
}
}

}